import { render, staticRenderFns } from "./EmployeeContactsDetailForm.vue?vue&type=template&id=ca39867e&scoped=true&"
import script from "./EmployeeContactsDetailForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeContactsDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca39867e",
  null
  
)

export default component.exports